import { Component, OnInit } from '@angular/core';
import { StoreService } from "../../../../../shared/services/store.service";
import { AuthService } from "../../../../../shared/services/auth/auth.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'public-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class PublicHeaderComponent implements OnInit {
  isLogged$ = this.authService.isLogged$;
  isGeneralMenuOpened = false;

  constructor(
    private authService: AuthService,
    public storeService: StoreService,
    public translateService: TranslateService
  ) {
  }

  ngOnInit() {
  }

  openGeneralMenu() {
    this.isGeneralMenuOpened = !this.isGeneralMenuOpened
  }
}
